export default __webpack_public_path__ + "static/media/btn_close.4da3d499.svg";